<template>
  <nav class="nav-container">
    <div class="nav-home">
      <router-link to="/" class="nav-link">Home</router-link>
    </div>
    <div class="nav-product-guide">
      <router-link to="/ProductGuides" class="nav-link"
        >Product Guides / Nutritional</router-link
      >
    </div>
    <div class="nav-logo"></div>
    <div class="nav-partners">
      <router-link to="/Partners" class="nav-link">Our Partners</router-link>
    </div>
    <div class="nav-contact">
      <router-link to="/Contact" class="nav-link">Contact</router-link>
    </div>
  </nav>

  <div class="grad-bar"></div>
  <div class="catchphrase">
    <h2>What does your school lunch look like today?</h2>
  </div>
  <div v-if="!guideRoutes.includes(currentRoute.name)">
    <div class="main-content-container">
      <div class="main-content-left"></div>
      <div class="main-content-middle">
        <router-view />
      </div>
      <div class="main-content-right"></div>
    </div>
  </div>
  <div v-else>
    <div class="guide-container">
      <div class="guide">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      guideRoutes: ["NTFToolkit", "GFSStockList", "ClemsStockList", "MPKVirtualRoadshow2020Menu"]
    };
  },
  computed: {
    currentRoute() {
      return this.$route;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Open Sans", "Arial", sans-serif;
}

/* NEED THESE GLOBAL UNSCOPED FOR PRODUCT GUIDE TABLES */
.thumbnail {
  border: 1px solid #333;
  border-radius: 4px;
  width: 150px;
  margin: 5px 0 0;
}

.mfglogo {
    max-height: 100px;
    max-width: 100px;
    width: auto;
    height: auto;
}

/* NAVIGATION BAR CONTAINER */
.nav-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: auto;
  grid-gap: 1em;
  align-items: center;
  text-align: center;

  background: #333;
  height: 120px;
}

/* NAVIGATION BAR ITEMS */

.nav-home {
  grid-column: 1;
}

.nav-product-guide {
  grid-column: 2;
}

.nav-logo {
  grid-column: 3;
  background-image: url("./assets/logos/mpk2.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 110px;
  padding: 10px;
}

.nav-partners {
  grid-column: 4;
}

.nav-contact {
  grid-column: 5;
}

.nav-link {
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  text-decoration: none;
  transition: color 0.3s ease-out;
  text-transform: uppercase;
  text-decoration: none;
}

.nav-link:hover {
  color: #3498db;
  padding: 0.25em 0.25em;
  font-weight: bold;
}

/* GRADIENT BAR AND CATCHPHRASE */
.grad-bar {
  width: 100%;
  height: 5px;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 400% 400%;
  -webkit-animation: gradbar 15s ease infinite;
  -moz-animation: gradbar 15s ease infinite;
  animation: gradbar 15s ease infinite;
}

.catchphrase {
  text-align: center;
  background: #000;
  color: whitesmoke;
}
.catchphrase h2 {
  padding: 10px;
}

/* MAIN CONTENT */
.main-content-container {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-template-areas: "main-content-left main-content-middle main-content-right";
}

.main-content-left {
  grid-area: main-content-left;
}

.main-content-middle {
  grid-area: main-content-middle;
}

.main-content-right {
  grid-area: main-content-right;
}

.guide-container {
  display: grid;
  grid-template-columns: 1fr 9fr 1fr;
  grid-template-rows: 1fr;
  gap: 0.25em 0.25em;
  grid-template-areas: ". guide .";
}
.guide {
  grid-area: guide;
}


/* MOBILE */
@media screen and (max-width: 700px) {
  .nav-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 3fr 1fr 1fr 1fr 1fr;
    gap: 1em 1em;
    height: auto;
  }

  .nav-home,
  .nav-product-guide,
  .nav-partners,
  .nav-contact,
  .nav-logo {
    grid-column: 1;
    padding: 0.25em;
  }

  .nav-logo {
    grid-row: 1;
    height: 100%;
  }

  .nav-home,
  .nav-product-guide,
  .nav-partners,
  .nav-contact {
    border-top: 1px solid #777;
  }

  .main-content-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    grid-template-areas: "main-content-middle";
  }

  .main-content-left,
  .main-content-right {
    display: none;
  }
  .main-content-middle {
    padding: 0.5em;
  }

  .guide-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    gap: 0px 0px;
    grid-template-areas: "guide";
  }
}

/* KEYFRAME ANIMATIONS */

@-webkit-keyframes gradbar {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@-moz-keyframes gradbar {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradbar {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
